import styled from '@emotion/styled';
import React from 'react';
import { mq } from './_shared/media';
import PropTypes from 'prop-types';
import { StyledH2Light } from './_shared/styled-headings';
import { StyledSection } from './_shared/styled-section';
import { StyledPLight } from './_shared/styled-headings';
import { StyledTagLight } from './_shared/styled-headings';
import { flexCenter } from './_shared/styled-mixins';
import Uber from '../assets/brands/uber.svg';
import Amazon from '../assets/brands/amazon.svg';
import Doordash from '../assets/brands/doordash.svg';
import Verizon from '../assets/brands/verizon.svg';
import Dunkin from '../assets/brands/dunkin.svg';
import FedEx from '../assets/brands/fedex.svg';

const StyledBlock = styled(StyledSection)`
  background-color: #fff;
  width: 100%;
  display: flex;
  ${flexCenter};
  flex-direction: column;
  padding: 3rem 0;

  color: var(--lightbg-content-color);
  text-align: center;
  font-size: 0.8rem;
`;

const StyledContent = styled.div`
  width: 100%;
  padding: 4rem calc((var(--space) / 2));
  text-align: center;
  font-size: 0.8rem;
`;

const StyledFeatures = styled.div`
  display: grid;
  max-width: 860px;
  margin: 0 auto;
  grid-template-columns: repeat(1, 1fr);
  justify-items: center;
  align-items: center;
  grid-gap: 1rem;
  padding: 1rem 0;

  ${mq.gt.sm} {
    grid-template-columns: repeat(3, 1fr);
  }

  svg {
    max-width: 150px;
    height: auto;
    padding: 1rem;
    filter: grayscale(100%);

    &:hover {
      filter: grayscale(0%);
      transition: 0.2s filter ease-in;
    }
  }
`;

const TopCompanies = ({ data }) => {
  const { summary } = data;

  return (
    <React.Fragment>
      <StyledBlock>
        <StyledContent>
          <StyledTagLight>WHERE COULD I WORK?</StyledTagLight>
          <StyledH2Light>You could land interviews at top companies</StyledH2Light>
          <StyledPLight dangerouslySetInnerHTML={{ __html: summary }} />
          <StyledFeatures>
            <Verizon />
            <Uber />
            <Doordash />
            <Amazon />
            <Dunkin />
            <FedEx />
          </StyledFeatures>
        </StyledContent>
      </StyledBlock>
    </React.Fragment>
  );
};

TopCompanies.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TopCompanies;
